import { createSlice } from '@reduxjs/toolkit';
import { setTpHeaders } from '../../common/js/utils/Helpers';
import Config from '../../common/js/utils/Config';
import Debug from '../../common/js/utils/Debug';
import { adminxApi } from './adminxApi';
import FT from '../../common/js/utils/FeatureToggles';

const initialState = {
  organizations: [],
  meta: {
    step: 'start',
  },
};

const getUrl = (type, param = {}) => {
  let dependency = param.dependency || 'aad';
  if (Config.isDemo(dependency)) {
    switch (type) {
      case 'getTechpulseToken':
        return Config.apiPath('demo', 'users', 'tp_token');
      default:
        return `${Config.getAssetBase()}data/`;
    }
  } else {
    switch (type) {
      case 'getTechpulseToken':
        return window.location.origin + '/services/oauth_handler/hpbp/token?redirect_uri=' + window.location.origin + '/signup';
      default:
        return '';
    }
  }
};
const extendedApi = adminxApi.injectEndpoints({
  endpoints: (builder) => ({
    getTechpulseToken: builder.mutation({
      query: (param = {}) => ({
        url: getUrl('getTechpulseToken', param),
        method: Config.isDemo() ? 'GET' : 'POST',
        ...(Config.isDemo()
          ? {}
          : {
              body: {
                ...param,
              },
            }),
        headers: setTpHeaders({}, FT('new-horizon-idptoken')),
      }),
    }),
  }),
  overrideExisting: false,
});

export const authSlice = createSlice({
  name: 'tpUserOrgs',
  initialState,
  reducers: {
    setOrganizations: (state, action) => {
      state.organizations = action.payload;
    },
    setMeta: (state, action) => {
      state.meta = {
        ...state.meta,
        ...action.payload,
      };
    },
  },
});
export const processTechpulseTokenError = (_e) => {
  Debug.log('Failed to generateTechpulseToken' + _e);
  let _continue = true;
  let e = _e;
  if (_e && _e.data && _e.data.errorDescr) {
    e = { response: { status: _e.data.errorCode, data: _e.data } };
  } else if (_e && _e.error && _e.error.status) {
    let _data = _e.error.data ? _e.error.data : {};
    e = { response: { status: _e.error.status, data: _data } };
  }
  if (e && e.response && e.response.status) {
    if (e.response.status == 401) {
      let data = e.response.data || {};
      if (data.errorDescr && data.errorDescr == 'RPL WAITING') {
        window.location = window.location.origin + '/ui/error/pending_approval';
        _continue = false;
      } else if (data.errorDescr && data.errorDescr == 'RPL BLOCKED') {
        window.location = window.location.origin + '/ui/error/blocked';
        _continue = false;
      } else {
        window.location = window.location.origin + '/ui/error/401';
        _continue = false;
      }
    } else if (e.response.status == 451) {
      window.location = window.location.origin + '/ui/error/blocked';
      _continue = false;
    } else if (e.response.status == 412) {
      if (e.response.errorDescr && e.response.errorDescr.indexOf('@hp.com') != -1) {
        window.location = window.location.origin + '/ui/error/412_hp';
      } else {
        window.location = window.location.origin + '/ui/error/412';
      }
      _continue = false;
    }
  }
  return _continue;
};
export const { setOrganizations, setMeta } = authSlice.actions;
export const { useGetTechpulseTokenMutation } = extendedApi;
